import axios from 'axios';
import { API_BASE_URL } from '../../config/apiConfig';

// Fetch general invoice list by CCCode (GET)
export const getGeneralInvoiceList = async (ccCode) => {
    try {
        const response = await axios.get(
            `${API_BASE_URL}/Accounts/GetGeneralInvoice`,
            { params: { CCCode: ccCode } }
        );
        return response.data;
    } catch (error) {
        if (error.response?.data) throw error.response.data;
        throw error.message || 'Failed to fetch general invoice list';
    }
};

// Fetch invoice detail by invoice number (GET)
export const getGeneralInvoiceByNo = async (invNo) => {
    try {
        const response = await axios.get(
            `${API_BASE_URL}/Accounts/GetGeneralInvoicebyNo`,
            { params: { InvNo: invNo } }
        );
        return response.data;
    } catch (error) {
        if (error.response?.data) throw error.response.data;
        throw error.message || 'Failed to fetch invoice details';
    }
};

// Bank / Cash access for the role (GET) — legacy GeneralInvoicePayment picks the form from this
export const getGeneralInvPayAccess = async (roleId, userId) => {
    try {
        const response = await axios.get(
            `${API_BASE_URL}/Accounts/GetGeneralInvPayAccess`,
            { params: { Roleid: roleId, Userid: userId } }
        );
        return response.data;
    } catch (error) {
        if (error.response?.data) throw error.response.data;
        throw error.message || 'Failed to fetch payment access';
    }
};

// Account heads of a CC (GET) — legacy cash form uses GetDCAByCC, not the cash DCA list
export const getDCAByCC = async (ccCode) => {
    try {
        const response = await axios.get(
            `${API_BASE_URL}/Accounts/GetDCAByCC`,
            { params: { CCCode: ccCode } }
        );
        return response.data;
    } catch (error) {
        if (error.response?.data) throw error.response.data;
        throw error.message || 'Failed to fetch account heads';
    }
};

// Sub account heads of a DCA (GET)
export const getSubDCAByDCA = async (dcaCode) => {
    try {
        const response = await axios.get(
            `${API_BASE_URL}/Accounts/GetSubDCAbyDCA`,
            { params: { DCACode: dcaCode } }
        );
        return response.data;
    } catch (error) {
        if (error.response?.data) throw error.response.data;
        throw error.message || 'Failed to fetch sub account heads';
    }
};

// Save general invoice cash payment (POST) — spInsertGenInvCashPayment
export const saveGenInvCashPayment = async (payload) => {
    try {
        const response = await axios.post(
            `${API_BASE_URL}/Accounts/SaveGenInvCashPayment`,
            payload,
            { headers: { 'Content-Type': 'application/json' } }
        );
        return response.data;
    } catch (error) {
        if (error.response?.data) throw error.response.data;
        throw error.message || 'Failed to save general invoice cash payment';
    }
};

// Save general invoice bank payment (POST)
export const saveGenInvBankPayment = async (payload) => {
    try {
        const response = await axios.post(
            `${API_BASE_URL}/Accounts/SaveGenInvBankPayment`,
            payload,
            { headers: { 'Content-Type': 'application/json' } }
        );
        return response.data;
    } catch (error) {
        if (error.response?.data) throw error.response.data;
        throw error.message || 'Failed to save general invoice payment';
    }
};
